<template>
    <div id="delete-widget" class="modal inmodal fade" role="dialog" aria-hidden="true" data-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <h2 class="modal-title">{{ t_deletewidget }}</h2>
                </div>
                <div class="modal-body text-center scrollBox" :style="'max-height: ' + maxBodyHeight + 'px;'">
                    <p v-if="multi === false" class="single">{{ t_warning_single }}</p>
                    <p v-if="multi === true" class="multi">{{ t_warning_multi }}</p>
                    <h2 class="widgetname" v-if="!multi && widgetName">{{ widgetName }}</h2>
                    <h2 class="widgetname" v-if="multi && widgetName">{{ widgetName.join(", ") }}</h2>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" class="btn btn-white btn-secondary" data-dismiss="modal">
                        {{ t_cancel }}
                    </v-btn>
                    <v-btn type="button" class="btn btn-primary submit" @click.stop.prevent="deleteWidget">
                        {{ t_delete }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import modalMixin from "../../common/modal-mixin";
    import toaster from "../../common/toaster";

    export default {
        mixins: [
            modalMixin,
        ],
        data: function () {
            return {
                t_close: Lang.langGet("Close"),
                t_deletewidget: Lang.langGet("Delete Widget"),
                t_warning_single: Lang.langGet("Do you really want to delete this widget?"),
                t_warning_multi: Lang.langGet("Do you really want to delete all selected widgets?"),
                t_cancel: Lang.langGet("Cancel"),
                t_delete: Lang.langGet("Delete"),
                t_delete_success: Lang.langGet("Widget was deleted successfully."),
                t_delete_fail: Lang.langGet("Failed to delete widget!"),
                multi: false,
                widgetName: '',
                widgetIDs: [],

                modalName: 'delete-widget',
            }
        },
        methods: {
            reset: function () {
                _.extend(this.$data, this.$options.data());
            },
            deleteWidget: function () {
                axios.post('/administration/widget/delete', {
                    id: this.widgetIDs
                }).then(() => {
                    toaster.success(this.t_delete_success);
                    EaseEventBus.fire('updateWidgetlist');
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }

                    toaster.error(this.t_delete_fail);
                });

                EaseEventBus.fire('hideModal', this.modalName);
            }
        },
        mounted() {
            EaseEventBus.listen('deleteWidget', (widget) => {
                this.reset();
                this.widgetName = widget.name;
                this.widgetIDs.push(widget.id);
                EaseEventBus.fire('showModal', this.modalName);

                this.$nextTick(() => {
                    this.calcModalHeight();
                });
            });

            EaseEventBus.listen('multiDeleteWidget', (data) => {
                this.reset();
                this.widgetName = data.names;
                this.widgetIDs = data.ids;
                this.multi = (this.widgetIDs.length > 1);
                if(!this.multi) {
                    this.widgetName = this.widgetName[0];
                }
                EaseEventBus.fire('showModal', this.modalName);
            });

            EaseEventBus.listen('hideModal', (modal) => {
                if (modal === this.modalName) {
                    this.reset();
                }
            });
        }
    }
</script>
